<section class="help-page">
  <div class="header d-flex d-md-block mb-0">
    <h1 class="d-block d-md-inline-block">{{ 'HELP_PAGE.HEADER' | translate }}</h1>
  </div>

  <div class="help-page__content astral-stack-s">
    <section class="astral-section-surface astral-stack-s">
      <h2 class="astral-section-heading">{{ 'HELP_PAGE.NEWS_HEADLINE' | translate }}</h2>
      <app-information-block [text]="'HELP_PAGE.NEWS_TEXT' | translate"></app-information-block>
      <button class="btn btn-outlined info-btn help-page__action" (click)="dhNews()">
        <img src="assets/icons/news-bell.svg" imageAlt="news" />{{ 'HELP_PAGE.NEWS_BTN' | translate }}
      </button>
    </section>

    <section class="astral-section-surface astral-stack-s">
      <h2 class="astral-section-heading">{{ 'HELP_PAGE.USER_MANUAL_HEADLINE' | translate }}</h2>
      <app-information-block [text]="'HELP_PAGE.USER_MANUAL_TEXT' | translate"></app-information-block>
      <div class="flex-gap-12">
        <button class="btn btn-primary info-btn" (click)="dhQAndA()">
          <img src="assets/icons/question-mark-white.svg" imageAlt="user manual" />{{ 'HELP_PAGE.Q_AND_A_BTN' | translate }}
        </button>
        <button class="btn btn-primary info-btn" (click)="dhUserManual()">
          <img src="assets/icons/question-mark-white.svg" imageAlt="user manual" />{{ 'HELP_PAGE.USER_MANUAL_BTN' | translate }}
        </button>
        <button class="btn btn-primary info-btn" (click)="dhElearning()">
          <img src="assets/icons/question-mark-white.svg" imageAlt="user manual" />{{ 'HELP_PAGE.ELEARNING_BTN' | translate }}
        </button>
      </div>
    </section>

    <section class="astral-section-surface astral-stack-s">
      <h2 class="astral-section-heading">{{ 'HELP_PAGE.ASK_US' | translate }}</h2>
      <astral-textarea [control]="form.controls['message']" [helpText]="'SUPPORT.HELP_TEXT.MAIL'" [rows]="5"></astral-textarea>
      <button
        class="btn btn-outlined help-page__action"
        (click)="sendMail()"
        [disabled]="isSendButtonDisabled || !form.controls['message'].value?.trim()"
      >
        @if (isSendingEmail) {
          <span class="spinner"></span>
        }
        <img src="assets/icons/mail.svg" imageAlt="ask us" />{{ 'HELP_PAGE.MAIL_TO_SUPPORT_BTN' | translate }}
      </button>
    </section>

    <section class="astral-section-surface support_container">
      <div class="row">
        <div class="col-md-6 col-12">
          <div class="text-content">
            <h6>{{ 'HELP_PAGE.SUPPORT.CONTACT' | translate }}</h6>
            <a class="email" href="mailto:fastighetssupport@hogia.se">{{ 'HELP_PAGE.SUPPORT.EMAIL' | translate }}</a>
            <a [ngClass]="{ phone: true, 'not-clickable-phone': !this.isMobile }" href="tel:+4630368830">
              {{ 'HELP_PAGE.SUPPORT.PHONE' | translate }}
            </a>
            <p>{{ 'HELP_PAGE.SUPPORT.SCHEDULE' | translate }}</p>
            <p class="secondary-text">{{ 'HELP_PAGE.SUPPORT.LUNCHTIME' | translate }}</p>
            <p class="secondary-text">{{ 'HELP_PAGE.SUPPORT.HOLIDAYS_SCHEDULE' | translate }}</p>
            @if (licenseNumber) {
              <p class="secondary-text">{{ 'HELP_PAGE.SUPPORT.LICENSE_NUMBER' | translate: { value: licenseNumber } }}</p>
            }
          </div>
        </div>

        <div class="col-md-6 col-12 mb-3">
          <div class="text-content">
            <h6>{{ 'HELP_PAGE.SALES.CONTACT' | translate }}</h6>
            <a class="email" href="mailto:fastighetssystem@hogia.se">{{ 'HELP_PAGE.SALES.EMAIL' | translate }}</a>
            <a [ngClass]="{ phone: true, 'not-clickable-phone': !this.isMobile }" href="tel:+4630368820">
              {{ 'HELP_PAGE.SALES.PHONE' | translate }}
            </a>
            <p>{{ 'HELP_PAGE.SALES.SCHEDULE' | translate }}</p>
            <p class="secondary-text">{{ 'HELP_PAGE.SALES.LUNCHTIME' | translate }}</p>
            <p class="secondary-text">{{ 'HELP_PAGE.SALES.HOLIDAYS_SCHEDULE' | translate }}</p>
          </div>
        </div>
      </div>
    </section>
  </div>
</section>
